import {writable} from 'svelte/store';
import {PAYMENT_GATEWAYS} from "../lib/constants";


let appObject = {
    tickets: [],
    products: [],
    payment_gateway_id: PAYMENT_GATEWAYS.CARDLINK,
    ticket_discount_id: 0, // 1: Flexy, 2: Discounted
    transfer_type_id: 0,
    transfer: null,
    language: null,

    full_name: '',
    phone: '',
    email: '',
    hotel_name: '',
    hotel_room: '',
    bill_info_json: {},

    settings: {},
    lang: {},
    cartStep: 0,

    device: 'sm',
    mapInitialized: false,

    ENABLE_XPAY: false,

    gTagItems: [], // Google tag manager items
};

const {get, set, update, subscribe} = writable(appObject);

const app = {
    set,
    update,
    subscribe,
    windowResize: () => {
        app.update(obj => {
            let win = window,
                doc = document,
                docElem = doc.documentElement,
                body = doc.getElementsByTagName('body')[0];

            obj.docWidth = win.innerWidth || docElem.clientWidth || body.clientWidth;
            obj.docHeight = win.innerHeight|| docElem.clientHeight|| body.clientHeight;

            if (obj.docWidth > 1199) {
                obj.device = "lg";
            } else if (obj.docWidth > 991) {
                obj.device = "md";
            } else if (obj.docWidth > 767) {
                obj.device = "sm";
            } else {
                obj.device = "xs";
            }

            return obj;
        })
    },

    initializeTickets: () => {
        let GROUPS = {};
        appObject.settings.discounts.map(item => {
            GROUPS[item.name] = {
                id: item.id,
                tickets: {}
            };
            item.tickets.map(ticket => {
                GROUPS[item.name].tickets[ticket.code] = {
                    id: ticket.id,
                    price: ticket.price,
                    original_price: ticket.original_price,
                }
            })
        });
        let TICKETS = {};
        appObject.settings.tickets.map(item => {
            TICKETS[item.code] = {
                id: item.id,
                code: item.code,
                name: item.name,
                price: item.price,
            }
        });

        app.update(obj => {
            obj.GROUPS = GROUPS;
            obj.TICKETS = TICKETS;
            return obj;
        });
    },
    createTransfer: (hotel, point, date, time) => {
        app.update(obj => {
            obj.transfer = {};
            if (hotel) {
                obj.transfer.hotel = {
                    id: hotel.id,
                    name: hotel.name,
                    lat_lng: hotel.lat_lng,
                }
            }
            if (point) {
                obj.transfer.pickup_point = {
                    id: point.id,
                    name: point.name,
                    lat_lng: point.lat_lng,
                }
                obj.prices = point.prices_json.transfer;
            }
            if (date && time) {
                obj.transfer.date_at = date;
                obj.transfer.pickup_time = time;
                obj.zone_id = time.zone_id;
            }

            return obj;
        })
    },
}

export default app;